import React, { Fragment, useState } from "react";
import { func, bool, string, element, oneOfType, any } from "prop-types";

import { Link } from "react-router-dom";
import { Button, Checkbox } from "../../../common";

import history from "../../../history";

const LinkButton = ({ to, children }) => (
  <div style={{ marginBottom: 15 }}>
    <Link
      to={to}
      className="btn-plain d-block text-info m-auto text-center"
      style={{ width: 264, marginBottom: 20 }}
    >
      {children}
    </Link>
  </div>
);

LinkButton.propTypes = {
  to: string.isRequired,
  children: oneOfType([element, string]).isRequired,
};

const WorkReferences = ({
  giveConsent,
  renderForm,
  renderCards,
  isFormVisible,
  showForm,
  app,
}) => {
  const [isAccepted, setAccepted] = useState(app.referencesConsent);
  const toggleAccepted = () => setAccepted(!isAccepted);

  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
        className="col-sm-8 col-lg-7 p-2"
      >
        {!app.referencesConsent ? (
          <Fragment>
            <h2 className="section-header">Add your references</h2>
            <section className="section-body p-1 text-bluishGray">
              <section>
                <p>
                  Before you add your references, please read and confirm the
                  declaration below.
                </p>
                <div className="form-group">
                  <label htmlFor="referencesConsentRadio">
                    I hereby authorise HRGO Recruitment to obtain references on
                    my behalf. I understand my personal data including full
                    name, National Insurance number and Date Of Birth will be
                    forwarded to those we contact to obtain an employment
                    reference. I give permission for any references received to
                    be shared with any third parties.
                  </label>
                  <Checkbox
                    label="I confirm the above statement"
                    isChecked={isAccepted}
                    onClick={toggleAccepted}
                    classes="mt-1"
                  />
                </div>
                <div className="w-100 d-flex justify-content-end flex-column-reverse flex-sm-row mt-3">
                  <Button
                    classes="btn btn-primary px-3 ml-sm-1"
                    onClick={() => giveConsent()}
                    disabled={!isAccepted}
                  >
                    Submit
                  </Button>
                </div>
              </section>
            </section>
          </Fragment>
        ) : (
          <Fragment>
            <div>
              {isFormVisible && renderForm()}
              <h2 className="section-header">Your references</h2>
              <section className="section-body p-1 text-bluishGray">
                <p className="pb-2">
                  Please give us details of those we can contact for a reference
                  if required. <br /> If you are unable to provide details for a
                  work reference, then we can accept details of someone to
                  contact for a character reference.
                </p>
                <div className="d-flex justify-content-end w-100 mt-1">
                  <Button
                    id="addReferenceBtn"
                    onClick={showForm}
                    classes="btn btn-primary ml-1"
                    styles={{ width: "120px" }}
                  >
                    Add
                  </Button>
                </div>
              </section>
              {renderCards()}
            </div>
          </Fragment>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            id="cancelBtn"
            onClick={() => {
              history.push("/profile");
            }}
            classes="btn btn-outline-dark"
          >
            Back to My Account
          </Button>
        </div>
      </div>
    </div>
  );
};

WorkReferences.propTypes = {
  referencesConsent: bool,
  giveConsent: func.isRequired,
  renderForm: func.isRequired,
  renderCards: func.isRequired,
  isFormVisible: bool.isRequired,
  showForm: func.isRequired,
  isEditing: bool.isRequired,
  loading: bool.isRequired,
  app: any,
};

export default WorkReferences;
